import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { EXPENSE_CLAIMS_ENABLED } from '../constants/api';

/**
 * When expense claims are disabled (e.g. production build), redirects to dashboard instead of rendering children.
 */
export const ExpenseFeatureGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!EXPENSE_CLAIMS_ENABLED) {
      navigate('/dashboard/my', { replace: true, state: { from: location.pathname } });
    }
  }, [navigate, location.pathname]);

  if (!EXPENSE_CLAIMS_ENABLED) {
    return null;
  }

  return <>{children}</>;
};

export default ExpenseFeatureGate;
